import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const WordPressWhite = forwardRef<SVGSVGElement, IconProps>(({ size = 20 }, forwardedRef) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 36"
      fill="none"
      ref={forwardedRef}
    >
      <g filter="url(#a)">
        <path
          fill="#fff"
          d="M6.083 17.588c0 4.554 2.647 8.49 6.484 10.354L7.08 12.905a11.461 11.461 0 0 0-.996 4.683Zm19.273-.581c0-1.422-.51-2.406-.949-3.173-.583-.947-1.13-1.75-1.13-2.698 0-1.057.802-2.042 1.932-2.042.051 0 .1.006.15.01a11.463 11.463 0 0 0-7.77-3.021 11.49 11.49 0 0 0-9.613 5.186c.27.008.524.014.74.014 1.203 0 3.066-.146 3.066-.146.62-.037.694.874.074.947 0 0-.623.074-1.317.11l4.19 12.462 2.518-7.551-1.793-4.911c-.62-.037-1.206-.11-1.206-.11-.62-.036-.547-.984.073-.948 0 0 1.9.146 3.03.146 1.203 0 3.067-.146 3.067-.146.62-.036.693.875.073.948 0 0-.624.073-1.317.11l4.158 12.367 1.148-3.834c.497-1.592.876-2.735.876-3.72Z"
        />
        <path
          fill="#fff"
          d="m17.79 18.594-3.452 10.03a11.505 11.505 0 0 0 7.07-.183 1.007 1.007 0 0 1-.081-.158l-3.537-9.69Zm9.894-6.527c.05.367.077.76.077 1.183 0 1.168-.218 2.48-.874 4.121l-3.515 10.161a11.5 11.5 0 0 0 5.721-9.945c0-2-.51-3.88-1.41-5.52Z"
        />
      </g>
      <defs>
        <filter
          id="a"
          width="46"
          height="46"
          x="-5"
          y="-3"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_5481_113184" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_5481_113184" result="shape" />
        </filter>
      </defs>
    </svg>
  )
})
